import React from 'react'
import utils from 'Utils'
import axios from 'axios'
import Matrix from 'scripts/Matrix'
import Loading from 'components/Loading'
import { Button } from '@material-ui/core'
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone'

class Purchase extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            couponLoading: false,
            discountBtnToggle: true,
            coupon: {
                name: '',
                id: ''
            },
            discountPrice: ''
        }
    }

    handleChange = e => {
        this.setState({ coupon: e.target.value })
        if (!e.target.value) this.setState({ discountBtnToggle: true })
    }

    toggle = () => this.setState({ discountBtnToggle: !this.state.discountBtnToggle })

    apiSendCoupon = async (entityId) => {
        if (!this.state.coupon)
            return this.props.openSnackbar('لطفا کد تخفیف را وارد کنید.')

        this.setState({ couponLoading: true })

        const params = {
            entity: 'ConsultRequest',
            code: this.state.coupon,
            entityId
        }

        let res = await axios.post(utils.urls.useCoupon, params, {
            headers: {
                'x-access-token': Matrix.getToken()
            }
        })
            .catch((e) => {
                console.log(e)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.props.openSnackbar(message)
            })

        this.setState({ couponLoading: false })

        if (!res) return
        if (!res.data.success) return this.props.openSnackbar(res.data.message || 'خطایی پیش آمده است')



        const { discount: { initialPrice, newPrice, id } } = res.data

        this.setState({
            discountPrice: initialPrice - newPrice,
            coupon: {
                ...this.state.coupon,
                id
            }
        })

        this.toggle()
    }

    apiDeleteCoupon = async () => {
        this.setState({ couponLoading: true })

        let url = `${utils.urls.deleteCoupon}/${this.state.coupon.id}`

        let res = await axios.delete(url, {
            headers: {
                'x-access-token': Matrix.getToken()
            }
        })
            .catch((e) => {
                console.log(e)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.props.openSnackbar(message)
            })

        if (!res) return
        if (!res.data.success) return this.props.openSnackbar('خطایی پیش آمده است')

        this.setState({
            couponLoading: false,
            coupon: {
                name: '',
                id: ''
            },
            discountPrice: null
        })

        this.toggle()
    }

    calcTotal = () => {
        const { consultCategory: { price }, wallet: { credit } } = this.props
        const { discountPrice } = this.state

        const fee = (price - discountPrice) - credit
        if (fee >= 0) return utils.formatMoney(fee)
        if (fee < 0) return 0
    }


    render() {
        return (
            <>
                <div className='purchase'>
                    <img src='/images/payment.svg' alt="مشاوره آنلاین پزشکی با بهترین دکترها" className='icon-image purchase-icon' />

                    <span>پزشک در کوتاهترین زمان پاسخگوی شما خواهد بود</span>

                    <div className="card">
                        <div className='card-title'>
                            <div className="card-indicator"></div>
                        کد تخفیف
                  </div>
                        <div className="row" style={{ justifyContent: 'flex-start' }}>
                            <div className="discount-code">
                                <div className="input-box">
                                    <input
                                        placeholder="افزودن کد تخفیف"
                                        style={{ padding: '3px 10px' }}
                                        value={this.state.coupon.name}
                                        onChange={this.handleChange}
                                    />
                                    <div className="btn-box">
                                        {this.state.discountBtnToggle ?
                                            <button
                                                className="action-btn"
                                                onClick={() => this.apiSendCoupon(this.props.consultRequest.id)}>
                                                اعمال
                                            </button> :
                                            <button
                                                className="cancel-btn"
                                                onClick={this.apiDeleteCoupon}>
                                                لغو
                                            </button>
                                        }
                                    </div>
                                </div>
                                {this.state.couponLoading && <Loading style={{ margin: 'auto', marginRight: 20, background: 'rgba(255, 255, 255, 0)', display: 'block', width: '35px', height: 25 }} />}
                            </div>
                        </div>
                        {this.state.firstConsultCode &&
                            <div className="row first-consult">
                                <span>کد تخفیف اولین مشاوره</span>
                                <span class="code">{this.state.firstConsultCode}</span>
                            </div>
                        }
                    </div>

                    <div className='card'>
                        <div className='card-title'>
                            <div className="card-indicator"></div>
                            اطلاعات پرداخت
                        </div>
                        <div className='row'>
                            <span>مشاوره با پزشک</span>
                            <div className='dot'></div>
                            <span className='price'>{utils.formatMoney(this.props.consultCategory.price)} تومان</span>
                        </div>
                        {this.state.discountPrice &&
                            <div className='row'>
                                <span>تخفیف</span>
                                <div className='dot'></div>
                                <span className='price'>{utils.formatMoney(this.state.discountPrice)} تومان</span>
                            </div>
                        }

                        <div className='row'>
                            <span>کیف پول</span>
                            <div className='dot'></div>
                            <span className='price'>{utils.formatMoney(this.props.wallet.credit)} تومان</span>
                        </div>
                        <div className='row total-credit'>
                            <span>مبلغ قابل پرداخت</span>
                            <div className='dot'></div>
                            <span className='price'>{this.calcTotal()} تومان</span>
                        </div>
                    </div>
                    <div>
                        <Button onClick={() => this.props.changeStep(1)} variant="outlined" style={{ borderRadius: '23px', marginBottom: '10px' }}>
                            تغییر متن مشاوره
                            <EditTwoToneIcon fontSize="small" />
                        </Button>
                    </div>
                </div>

                <div className="terms">
                    <div className="terms__checkbox">
                        <div>در صورت ادامه <span className="link" onClick={this.props.openTermsAndConditionModal}>قوانین و مقررات</span> را قبول دارم</div>
                    </div>
                </div>
                <div className='purchase-btn button' style={{ marginBottom: 0 }} onClick={this.props.finalizePay}> پرداخت و ثبت نهایی</div>
            </>
        )
    }
}

export default Purchase